// extracted by extract-css-chunks-webpack-plugin
module.exports = {"wrap":"read-all-area__wrap--3j6yu"};